<ng-container *ngIf="vm$ | async as vm">
  <form name="frmZoek" (ngSubmit)="zoekSubject.next(true)">

    <div class="zoekpanel-row">
      <h1 class="head1">Zoeken agendapunten</h1>
      <div class="zoekinput-row">
        <input aria-label="Geef zoektermen in" class="zoekinput" type="text" name="SearchFor" [(ngModel)]="vm.zoekArg.SearchFor">
        <button type="submit" class="btn btn-primary ">
          zoeken <i class="icon-zoom"></i>
        </button>
        <button type="button" class="btn btn-primary" (click)="navigateToZoekDocumentenZitting(vm.zoekArg)">documenten
          zitting
          <i class="icon-zoom"></i></button>
        <button type="button" class="btn btn-primary" (click)="navigateToZoekNotities(vm.zoekArg)">notities <i
            class="icon-zoom"></i></button>
      </div>

      <div class="zoekfilters-row">
        <select name="soortzitting" title="Filter soort zitting" [(ngModel)]="vm.zoekArg.SoortZittingId">
          <option [ngValue]="null">Alle zittingen</option>
          <option [ngValue]="soortZitting.Id" *ngFor="let soortZitting of vm.soortenZitting">
            {{soortZitting.Omschrijving}}</option>
        </select>
        <select name="periodefilter" title="Filter periode" [(ngModel)]="vm.zoekArg.PeriodeFilter" class="zoekfilters-periodefilter">
          <option [value]="periodeFilter.arg" *ngFor="let periodeFilter of vm.periodeFilters">{{periodeFilter.Title}}
          </option>
        </select>
        <select name="andorfilter" title="Optie combineer zoektermen" [(ngModel)]="vm.zoekArg.CombineWordsWith">
          <option selected="selected" value=" or ">Eén van de ...</option>
          <option value=" and ">Alle ...</option>
          <option value="exact">Exact</option>
        </select>
        <a href="#" role="button" (click)="wisZoekFilters()" class="c2-clickable">wissen</a>
      </div>

      <div class="zoekinput-row" *ngIf="vm.zoekArg.PeriodeFilter==='C'">
        <label for="zoekpunt_vanjaar">Van jaar</label>
        <input id="zoekpunt_vanjaar" [(ngModel)]="vm.zoekArg.VanJaar" name="Van" class="jaar" type="number" min="1970" max="2099" />
        <label for="zoekpunt_totjaar">Tot jaar (optioneel)</label>
        <input id="zoekpunt_totjaar" [(ngModel)]="vm.zoekArg.TotJaar" name="Tot" class="jaar" type="number" min="" max="2099" />
      </div>

    </div>

    <div role="list" class="zoekresults-panel-row" #zoekresults>
      <span class="head3" *ngIf="vm.zoekResults.length==0">Geen resultaten</span>
      <div  role="listitem" *ngFor="let result of vm.zoekResults trackBy:getZoekResultId" class="zoekresultspanel-item-row"
        [id]="'p_'+result.AgendapuntId">
        <h2 class="head2" *ngIf="result.isZittingBreak">{{result.SoortZitting}} {{result.DatumZitting | date}}</h2>

        <a  class="head3 titel-row c2-clickable" href="#" *ngIf="result.isPuntBreak" (click)="navigateToDetailPunt(result)">
          {{result.Volgnummer}} <span [innerHTML]="result.Titel | highlight:vm.zoekArg.SearchFor"></span>
        </a>

        <a class="zoekresultspanelitem-document-row c2-clickable" href="#" (click)="navigateToDetailDocument(result)"
          *ngIf="result.DocumentTitel"><i class="icon-file"></i> {{result.DocumentTitel}} ({{result.Ext}})</a>

      </div>
      <div class="zoekresults-buttons-row" *ngIf="vm.hasMoreResults">
        <button (click)="zoekMeerSubject.next(true)" type="button" class="btn btn-default">Meer resultaten</button>
      </div>
    </div>

  </form>
</ng-container>